<template>
  <div class="p-6 text-center">
    <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation policy</h3>
    <p class="text-[14px] text-grey-light-600 mt-1">
      Please note that cancellations and refunds are handled by the merchant, not LayUp. For any questions, please
      contact the merchant directly.
    </p>
    <div class="mt-6">
      <Button variant="outline" class="flex-1" @click="$emit('close')">Close</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';

defineEmits<{ close: [] }>();
</script>
